import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Hotkey } from 'ui-components/components/hotkey';
import { Text, TextType } from 'ui-components/components/text';
import { SimpleModal } from '../simple-modal';
import { useModal } from '../../hooks/use-modal';
import { OrderScanToSearchModal } from '../modals/order-scan-to-search-modal/';
import ModalPortal from '../modal-portal/index';
import { useCtrlOrCmd } from './hotkeys-modal/hooks';
import { useBarcodeScanningFeatureGate } from '../../feature-gates/use-barcode-scanning-feature-gate';

const messages = defineMessages({
  name: {
    description: 'modalHotkey.orders.scanToSearch',
    defaultMessage: 'Scan to Search Modal',
    id: 'x46MC6',
  },
  gatedFeatureTitle: {
    description: 'title for a feature that will search for an order when a user scans a barcode',
    defaultMessage: 'Scan to Search',
    id: 'LqajHD',
  },
});

export const barcodeContent = '+RUYW5KDX3S4M=';
export const hotkey = ['Ctrl', 'shift', 's'];
const upcaseS = 'S';

const OpenOrderScanToSearchModalHotkey = () => {
  const { isOpen, open, close } = useModal();

  const intl = useIntl();
  const ctrlOrCmD = useCtrlOrCmd();

  const { isFeatureEnabled, disabledMessage } = useBarcodeScanningFeatureGate(); // @design-input-pending

  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: [ctrlOrCmD, upcaseS],
      doNotTrack: true,
      barcode: barcodeContent,
      handler: open,
      hotkey: [upcaseS],
      matches: (str, inputBuffer) => {
        const curr = inputBuffer[inputBuffer.length - 1];
        const isBarcodeScan = str === barcodeContent.toLowerCase();
        return isBarcodeScan || (curr.key === 's' && curr.hasShift && curr.hasCtrlEquivalent);
      },
      legacyCategory: 'general',
      name: intl.formatMessage(messages.name),
    }),
    [intl, open, ctrlOrCmD],
  );

  return (
    <>
      <Hotkey hotkey={hotkeyMetadata} />
      {isOpen && (
        <ModalPortal onClose={close}>
          {isFeatureEnabled ? (
            <OrderScanToSearchModal onClose={close} />
          ) : (
            <SimpleModal headerMessage={messages.gatedFeatureTitle} onClose={close} size='small'>
              <Text textType={TextType.Paragraph} value={disabledMessage} />
            </SimpleModal>
          )}
        </ModalPortal>
      )}
    </>
  );
};

export default OpenOrderScanToSearchModalHotkey;
